import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import classNames from 'classnames';
import { Collapse } from '@mui/material';
import { useState } from 'react';
import EMRPatientResult from './EMRPatientResult';
import { ReactComponent as ArrowIcon } from '../../../../../../../assets/icons/patientsWidgetsIcons/arrow.svg';
import { IEMRPatient } from '../../../../../../../services/intakeDataService/emrPatientsService/types';

const numberOfShownItem = 3;

const EMRPatientResults = ({
  selected,
  onChangeResults,
  EMRPatientsList,
}: {
  selected?: number;
  onChangeResults(id?: number): void;
  EMRPatientsList?: IEMRPatient[];
}) => {
  const [collapsed, setCollapsed] = useState<boolean>(true);

  return EMRPatientsList?.length ? (
    <>
      <div className="text-sm flex flex-col">
        <div
          className={classNames(
            'font-semibold leading-normal pb-1',
            styles.resultTitle,
          )}
        >
          Results not imported yet
        </div>
        Select a result and click "Import"
      </div>
      <Collapse
        classes={{ root: 'p-2', wrapperInner: 'flex flex-col gap-4' }}
        in={!collapsed}
        collapsedSize={EMRPatientsList?.length > 2 ? 270 : 140}
        timeout={300}
        enter
        exit
      >
        {EMRPatientsList?.slice(0, collapsed ? numberOfShownItem : EMRPatientsList?.length).map(
          (patient) => (
            <EMRPatientResult
              key={patient.patientId}
              patient={patient}
              selected={selected}
              onChange={(id) => onChangeResults(id)}
            />
          ),
        )}
        {EMRPatientsList?.length > numberOfShownItem ? (
          <div
            className={classNames(
              'text-sm cursor-pointer font-semibold flex items-center justify-center text-primary-p3',
              {
                [styles.expanded]: !collapsed,
              },
            )}
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          >
            {`Show ${collapsed ? 'more' : 'less'}`}
            <ArrowIcon />
          </div>
        ) : null}
      </Collapse>
    </>
  ) : null;
};

export default observer(EMRPatientResults);
